import * as _ from 'lodash';
import * as debug from 'debug';

import { Injectable } from '@angular/core';
import { CrudApiProvider } from '../crud-api/crud-api';
import { ConfigProvider } from '../config/config';
import { UserProvider } from '../user/user';
import { ToolsProvider } from '../tools/tools';

@Injectable()
export class PinnedPostsProvider {
  log = debug('app:PinnedPostsProvider');

  loaded = false;
  pinnedPosts: any = [];

  constructor(
    public crud: CrudApiProvider,
    public config: ConfigProvider,
    public user: UserProvider,
    public tools: ToolsProvider
  ) {}

  spinUp() {
    this.fetchPinnedPosts();
  }

  private fetchPinnedPosts() {
    this.crud
      .get('/api/posts', {
        'states.isPinned': true,
      })
      .then(res => {
        this.pinnedPosts = res.data;
        this.loaded = true;
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/posts/pinned-posts.ts